import locales from '@/configs/locales'

export default {
  product: {
    name: 'Project',
    version: '1.0.1'
  },

  locales
}
